import Navbar from "../Components/Navbar";
// import AboutBanner from "../Components/AboutBanner";
import AboutUs from "../Components/AboutUs";
import Mission from "../Components/Mission";
import Footer from "../Components/Footer";

function About() {
  return (
    <>
      <Navbar />

      {/* <AboutBanner /> */}

      <AboutUs />

      <Mission />

      <Footer />
    </>
  );
}

export default About;